import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/teacher/project/page',
    add:'/api-ir/teacher/project/add',
    update:'/api-ir/teacher/project/edit',
    info:'/api-ir/teacher/project/info/',
    del:'/api-ir/teacher/project/delete/',
}
// 查询协议管理列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增协议管理
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改协议管理
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询协议管理信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除协议管理
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
